import { createSlice } from '@reduxjs/toolkit';

import type { IError } from '../../../types';

const initialState: IError = {
  code: null,
  message: null,
  type: null,
  action: null,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError(state, action) {
      return action.payload;
    },
    resetError() {
      return initialState;
    },
  },
});

export const { setError, resetError } = errorSlice.actions;

export default errorSlice.reducer;
